export { SkillPointOfSale as default } from './SkillPointOfSale';
